import { AchBatchRepository } from '~/repositories/Transfer/AchBatchRepository';
import { TransferBatchRepository } from '~/repositories/Transfer/TransferBatchRepository';
import { ACHTransferBatch, TransferBatch } from '~/typings/API';

import { createApiHook } from './utils/createApiHook';

export const useTransferBatch = createApiHook<TransferBatch, GetRequestType>(TransferBatchRepository.get);

export const useAchBatch = createApiHook<ACHTransferBatch, GetRequestType>(AchBatchRepository.get);
